import React, { useState } from 'react'
import { TouchableOpacity, View } from 'react-native'
import { Icon, Text } from '@src/components/base'
import { StyleService, useStyleSheet } from '@src/style/service'

interface ProgramDetailsProps {
  expanded?: boolean
  details: string[]
  title?: string
}

export const ProgramDetails = (props: ProgramDetailsProps) => {
  const { expanded: expandedFromProps = false, title = "What's included", details } = props

  const styles = useStyleSheet(themedStyles)

  const [expanded, setExpanded] = useState(expandedFromProps)

  const toggleExpanded = () => {
    setExpanded((prev) => !prev)
  }

  return (
    <TouchableOpacity
      style={styles.details}
      onPress={toggleExpanded}
      accessibilityLabel={title}
      activeOpacity={0.7}
    >
      <View style={styles.header}>
        <Text type="regular">{title}</Text>
        <Icon name={expanded ? 'caret-up' : 'caret-down'} style={styles.chevronIcon} />
      </View>

      {expanded && (
        <View style={styles.detailsList}>
          {details.map((item, index) => (
            <View key={index} style={styles.row}>
              <Text type="small">•</Text>
              <Text type="small">{item}</Text>
            </View>
          ))}
        </View>
      )}
    </TouchableOpacity>
  )
}

const themedStyles = StyleService.create({
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  details: {
    backgroundColor: 'theme.surface.base3',
    padding: 16,
    borderRadius: 16,
  },
  chevronIcon: {
    width: 20,
    height: 20,
  },
  detailsList: {
    marginTop: 8,
    gap: 8,
  },
  row: {
    flexDirection: 'row',
    gap: 8,
  },
})
